export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    // Use your specific tenant ID for tighter security, e.g.:
    //   authority: 'https://login.microsoftonline.com/<your-tenant-id>'
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes requested at login — openid/profile/email give us the ID token
// with the user's name and email address.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
